/**
 * 统一日期格式化工具
 * 前台和后台共用，基于 dayjs
 */
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/en';

dayjs.extend(relativeTime);

/**
 * 设置 dayjs locale
 */
const setLocale = (language: string) => {
  dayjs.locale(language.startsWith('zh') ? 'zh-cn' : 'en');
};

/**
 * 格式化相对时间（dayjs fromNow）
 * 例如："3 days ago" / "3天前"
 */
export const formatRelativeTime = (date: string | Date, language: string = 'en'): string => {
  setLocale(language);
  return dayjs(date).fromNow();
};

/**
 * 格式化完整日期
 * @param format 默认 'LL'（如 January 1, 2024 / 2024年1月1日）
 */
export const formatDate = (
  date: string | Date,
  language: string = 'en',
  format: string = 'LL'
): string => {
  setLocale(language);
  return dayjs(date).format(format);
};

/**
 * 格式化日期时间
 * 例如："Jan 1, 2024 14:30" / "2024年1月1日 14:30"
 */
export const formatDateTime = (
  date: string | Date,
  language: string = 'en',
  format: string = 'LLL'
): string => {
  setLocale(language);
  return dayjs(date).format(format);
};
